export const SET_DELIVERY_CONTRACTED = 'setDeliveryContracted';
export const GET_DELIVERY_CONTRACTED = 'getDeliveryContracted';
export const SET_STATUS_DELIVERY = 'setStatus';
export const GET_STATUS_DELIVERY = 'getStatus';
export const SET_APP_LOADING = 'setLoading';
export const GET_APP_LOADING = 'loading';
export const CALCULATE_FREIGHT = 'calculateFreight'
export const GET_FREIGHT = 'getFreight';
export const SET_DISABLE_TO_HIRE = 'setDisableToHire';
